module.exports = __webpack_public_path__ + "e482f3050d48907726017b877370f69e.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/lazy-31.png
// module id = 2229
// module chunks = 0